// TODO: rewrite these classes with a real constructor instead of "cast", like for example lot.class
export class UserRight {
  /**
   *
   */
  public id = -1;

  /**
   *
   */
  public name = '';

  /**
   *
   */
  public date = '';

  /**
   *
   */
  public parent = -1;

  /**
   *
   */
  public right = '';

  /**
   *
   */
  public identifier = -1;

  /**
   *
   */
  public file = '';

  /**
   *
   */
  public local: boolean;

  /**
   *
   */
  public isModule: boolean;

  /**
   *
   */
  public rights: UserRight[];

  /**
   * @param oJson the json data
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public cast(oJson: any) {
    this.id = oJson.modules_id;
    this.name = oJson.name;
    this.date = oJson.modules_date;
    this.parent = oJson.modules_parent;
    this.right = oJson.modules_droits;
    this.identifier = oJson.modules_identifer;
    this.file = oJson.modules_fichier;
    if (oJson.modules_local !== undefined) {
      this.local = oJson.modules_local >= 1;
    }
    if (oJson.is_module !== undefined) {
      this.isModule = oJson.is_module >= 1;
    }
    if (oJson.rights instanceof Array) {
      this.rights = [];
      // TODO:  Set up the correct type
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      oJson.rights.forEach((right: any) => {
        const userRight = new UserRight();
        userRight.cast(right);
        this.rights.push(userRight);
      });
    }
  }

  /**
   * @returns string
   */
  public stringify() {
    const json = this.DBconvert();
    return JSON.stringify(json);
  }

  /**
   * @returns Object
   */
  private DBconvert() {
    // TODO:  Set up the correct type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rightstab: any[] = [];
    const json = {
      is_module: this.isModule ? 1 : 0,
      modules_date: this.date,
      modules_droits: this.right,
      modules_fichier: this.file,
      modules_id: this.id,
      modules_identifer: this.identifier,
      modules_local: this.local ? 1 : 0,
      name: this.name,
      modules_parent: this.parent,
      rights: rightstab,
    };
    this.rights.forEach((userRight: UserRight) => {
      const rights = userRight.DBconvert();
      json.rights.push(rights);
    });
    return json;
  }
}
